<div class="container-fluid ter-container nc"
infiniteScroll
[infiniteScrollDistance]="4"
[infiniteScrollThrottle]="500"
(scrolled)="scrolledDown()"
[scrollWindow]="false"
style="flex: auto;">
<!-- <devices-layout [devices]="devices" (addNewDevice)="addNewDevice($event)"></devices-layout> -->
<devices-list [devices]="devices" (addNewDevice)="addNewDevice($event)" [showHeader]="true"></devices-list>
</div>